import React, { useState } from "react";
import "./DataAnalysis.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/api";
import { FaHome } from "react-icons/fa";

import {
  FaChartBar,
  FaDatabase,
  FaUserTie,
  FaBriefcase,
  FaChartLine,
  FaCertificate,
} from "react-icons/fa";

const DataAnalysis = () => {
  const COURSE_NAME = "Data Analysis";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    mode: "",
    level: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "name") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    if (name === "email") {
      updatedValue = value.toLowerCase();
    }

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    if (
      !formData.name ||
      !formData.phone ||
      !formData.email ||
      !formData.mode ||
      !formData.level
    ) {
      setError("Please fill all fields");
      setLoading(false);
      return;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      setError("Phone number must be exactly 10 digits");
      setLoading(false);
      return;
    }

    if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(formData.email)) {
      setError("Enter a valid email address");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ...formData,
        courseName: COURSE_NAME,
      };

      const res = await axios.post(API_URL, payload);

      if (res.data.success) {
        window.open(res.data.whatsappUrl, "_blank");

        setMessage("Redirecting to WhatsApp...");

        setFormData({
          name: "",
          phone: "",
          email: "",
          mode: "",
          level: "",
        });

        setTimeout(() => {
          setMessage("");
        }, 3000);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }

    setLoading(false);
  };

  return (
    <div className="da-hero">
      {message && <div className="success-msg">{message}</div>}
      {error && <div className="error-msg">{error}</div>}

      <div className="breadcrumb">
        <Link to="/" className="home-link">
          <FaHome /> Home
        </Link>
        <span className="separator"> / </span>
        <span className="current">Data Analysis</span>
      </div>

      <div className="overlay">
        <div className="hero-left">
          <span className="badge">AAPS Career</span>

          <h1>
            <span className="white">Data </span>
            <span className="orange">Analysis </span>
            <span className="white">Course</span>
          </h1>

          <ul className="points">
            <li>Learn how to analyze and interpret real-world data</li>
            <li>Work with datasets using Excel, SQL, and Python</li>
            <li>Build dashboards and reports for business insights</li>
            <li>Understand data cleaning and preprocessing techniques</li>
            <li>Prepare for Data Analyst roles with practical skills</li>
          </ul>

          <div className="features">
            <div>
              <FaChartBar /> Data Visualization
            </div>
            <div>
              <FaDatabase /> Database Handling
            </div>
            <div>
              <FaUserTie /> Expert Trainers
            </div>
            <div>
              <FaBriefcase /> Placement Support
            </div>
            <div>
              <FaChartLine /> Career Growth
            </div>
            <div>
              <FaCertificate /> Certification
            </div>
          </div>

          <div className="learn">
            <h3>What You Will Learn</h3>
            <div className="tags">
              <span>Excel</span>
              <span>SQL</span>
              <span>Python</span>
              <span>Power BI</span>
              <span>Tableau</span>
              <span>Data Cleaning</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="form-card">
            <h3>Fill Your Details</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                autoComplete="off"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <select
                name="mode"
                value={formData.mode}
                onChange={handleChange}
                required
              >
                <option value="">Select Training Type</option>
                <option value="Classroom">Classroom</option>
                <option value="Online">Online</option>
              </select>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
                required
              >
                <option value="">I am...</option>
                <option value="Beginner">Beginner</option>
                <option value="Student">Student</option>
                <option value="Working Professional">
                  Working Professional
                </option>
              </select>

              <button type="submit" className="book-btn" disabled={loading}>
                {loading ? "Submitting..." : "Book Now"}
              </button>
            </form>

            <div className="divider">OR</div>

            <a href="tel:+919573470659" className="call-btn">
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataAnalysis;
